module.exports = __webpack_public_path__ + "fonts/Gotham-Ultra.f6e21da3.otf";